export default __webpack_public_path__ + "static/media/plus.7fe025d8.svg";